export default "__VITE_ASSET__Ch5xn4oH__"